import { PropsWithChildren, useState } from 'react';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody, Col, Row } from 'reactstrap';
import './ReportsAccordion.scss';
import { useTranslation } from 'react-i18next';

import AddPoisonModal from 'pages/VisitReports/Modals/AddPoisonModal';

interface ReportsAccordionProps {
  title: string;
  noDataText: string;
  icon?: string;
  data?: any[];
  mapElement?: (data: any) => JSX.Element;
  slug?: string;
  id?: string;
  hasModal?: boolean;
}
const ReportsAccordion: React.FC<PropsWithChildren<ReportsAccordionProps>> = ({
  title,
  noDataText,
  icon,
  data,
  mapElement,
  children,
  slug,
  id,
  hasModal,
}) => {
  const [openLeftIcon, setOpenLeftIcon] = useState('');
  const [isMangeModalOpen, setIsManageModalOpen] = useState(false);
  const { t } = useTranslation();
  const toggleLeftIcon = (id: any) => {
    if (openLeftIcon !== id) {
      setOpenLeftIcon(id);
    }
    if (openLeftIcon === id) {
      setOpenLeftIcon('');
    }
  };
  return (
    <Row className="m-2">
      <Col lg={12}>
        <Accordion
          className="lefticon-accordion custom-accordionwithicon accordion-border-box m-1"
          open={openLeftIcon}
          toggle={toggleLeftIcon}
          key={title}
        >
          <AccordionItem>
            <AccordionHeader targetId="TechVulData" className="py-3 accordion-header">
              <i className={`ri-arrow-right-s-line  fs-18 chevron ${openLeftIcon ? 'open' : ''}`} />
              {icon ? <i className={`${icon}`} style={{ marginRight: '5px' }} /> : null}
              {title}
            </AccordionHeader>
            <AccordionBody accordionId="TechVulData">
              {(!data || data?.length === 0) && !children ? (
                <h5 className="text-center text-danger">{noDataText}</h5>
              ) : null}
              {mapElement && data ? data.map(mapElement) : null}
              {children}
              {hasModal && (
                <div className="row mt-3">
                  <div className="col-12 text-center">
                    <AddPoisonModal
                      slug={slug}
                      id={id}
                      isOpen={isMangeModalOpen}
                      onClose={() => {
                        setIsManageModalOpen(false);
                      }}
                    />
                    <button
                      id="Button_addEncounterToReportModal"
                      className="card-animate btn btn-ghost-success btn-md fs-20 m-1 w-100"
                      type="button"
                      onClick={() => {
                        setIsManageModalOpen(true);
                      }}
                    >
                      <i className="ri-search-eye-line fs-20 m-2" />
                      {t('UsedPoisons.accordion.add-button')}
                    </button>
                  </div>
                </div>
              )}
            </AccordionBody>
          </AccordionItem>
        </Accordion>
      </Col>
    </Row>
  );
};
export default ReportsAccordion;
